import bodyHelperTypes from "../utils/BodyHelperTypes";


const _1915C_Content = [
  {
    format: bodyHelperTypes.title,
    order: 10,
    content: "Under Construction, Page Coming Soon",
  },
];

export default _1915C_Content;
